import { useEffect, useState } from "react";

const getFormattedCountdown = secs => {
	var hours   = Math.floor ( secs / 3600 );
	var minutes = Math.floor ( ( secs - ( hours * 3600 ) ) / 60 );
	var seconds = secs - ( hours * 3600 ) - ( minutes * 60 );

	if ( hours < 10 ) {
		if ( hours == 0 ) hours = "";
		else hours = "0" + hours;
	}

	if ( minutes < 10 ) {
		if ( !hours && minutes == 0 ) minutes = "";
		else minutes = "0" + minutes;
	}

	if ( seconds < 10 ) {
		seconds = "0" + seconds;
	}

	if ( !hours && !minutes ) return seconds + "s";
	if ( !hours && minutes ) return minutes + ":" + seconds;

	return hours + ":" + minutes + ":" + seconds;
};

const useTimer = ( { initSecs, onTimerEnd } ) => {
	// Combining useState values together for brevity
	const [ secs, setCountdown ] = useState ( initSecs );

	/**
   * Triggers each second and whenever mins/seconds updates itself.
   */
	useEffect ( () => {
		// Timer that decrements itself each second and updates the mins/seconds downwards
		if ( initSecs <= 0 ) return;

		let timerInterval = setInterval ( () => {
			// Countdown timer up, clear timer and do nothing
			/* if ( mins === 0 && secs === 0 ) {
				clearInterval ( timerInterval );
				onTimerEnd ();
			} else if ( secs === 0 ) {
				// Might be correct to set seconds to 59, but not sure
				// should decrement from 60 seconds yeah?
				setCountdown ( [ mins - 1, 59 ] );
			} else {
				setCountdown ( [ mins, secs - 1 ] );
			} */

			if ( secs === 0 ) {
				clearInterval ( timerInterval );
				onTimerEnd ();
			} else {
				setCountdown ( prevState => prevState - 1 );
			}
		}, 1000 );

		return () => {
			clearInterval ( timerInterval );
		};
	}, [ secs ] );

	useEffect ( () => {
		setCountdown ( initSecs );
	}, [ initSecs ] );

	// return ( { mins: mins < 10 ? `0${ mins }` : mins, secs: secs < 10 ? `0${ secs }` : secs } );Z

	return getFormattedCountdown ( secs );

};

export default useTimer;